module.exports = __webpack_public_path__ + "img/pr-4.35a7339d.png";